<template>
<ValidationObserver ref="observer">
  <form ref="edit_business_unit_form" @submit.prevent="handleSubmit(updateBusinessUnit)">

    <md-card>

      <!-- <md-card-header class="md-card-header-icon">
        <div class="card-icon">
          <md-icon>perm_identity</md-icon>
        </div>
        <h4 class="title">
          Edit Client Master
        </h4>
      </md-card-header> -->
      <md-card-content>
        <div class="md-layout">
          <div class="md-layout-item md-small-size-100">
              <validation-provider rules="buname" v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Business Unit Name</label>
                  <md-input v-model="business_unit.business_unit_name" required/>
                  <validation-error :errors="apiValidationErrors.business_unit_name" />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
            </div>
        </div>


        <div class="md-layout">
          <div class="md-layout-item md-small-size-100">
              <validation-provider v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Remark</label>
                  <md-textarea v-model="business_unit.business_unit_remark" md-counter="255" maxlength="255" md-autogrow></md-textarea>
                  <validation-error
                    :errors="apiValidationErrors.business_unit_remark"
                  />
                  <md-avatar >
                    <md-icon style="color:blue;">report</md-icon>
                    <md-tooltip md-direction="left">You can enter to add new row</md-tooltip>
                  </md-avatar>
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
            </div>
        </div>
      </md-card-content>
      

      <md-card-actions>
        <md-button class="md-info md-dense" @click="editConfirmation">
          Update
        </md-button>
      </md-card-actions>
    </md-card>

  </form>
</ValidationObserver>
</template>

<script>
  import {ValidationError} from "@/components";
  import formMixin from "@/mixins/form-mixin";
  import { extend , ValidationObserver } from 'vee-validate';
  import { required } from 'vee-validate/dist/rules';
  import Vue from 'vue'
  import VueSweetalert2 from 'vue-sweetalert2';
  import Swal from 'sweetalert2';

  Vue.use(VueSweetalert2);

extend('buname', {
  ...required,
  message: 'Name Field is required'
});

  Vue.use(VueSweetalert2);
  export default {
    name: "edit-business-unit--test",
    
    props: {
      data_id: null,
    },

    components: {ValidationError, ValidationObserver},

    mixins: [formMixin],

   data: () => ({
      business_unit: [],
    }),

    created() {
      this.getBusinessUnitData();
    },


    methods: {
      
      // fungsi untuk tombol direct ke list client master
      backtoList(id) {
      this.$router.replace({ name: 'List Business Unit' })
    },

      // fungsi untuk mendapatkan data yang akan di edit dengan id yang dikirim bersamaan dengan route
      async getBusinessUnitData(){
        //check apakah id ada di route
        if(this.data_id){
          
        //jika ada ambil data dari api
        await this.$store.dispatch("fms_business_unit/get", this.data_id.id)
        this.business_unit = await this.$store.getters["fms_business_unit/business_unit"]
        }
        else{
          //jika tidak ada kembali ke list
          // await this.$router.replace({name: 'List Business Unit'});
          this.$parent.$parent.modalCloseEditFormBu();
        }
      },

      // validasi menggunakan sweetalert  sebelum mengubah data
      async editConfirmation(id) {
        const isValid = await this.$refs.observer.validate();
      if (!isValid) {
        return
      }
      Swal.fire({
        title: 'Are you sure?',
        text: 'The data will be edited!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, Edit it!',
        cancelButtonText: 'No, cancel!',
        buttonsStyling: true
        }).then((result) => {
          if (result.value){
            this.updateBusinessUnit(id)
          }
        });
    },


    // fungsi edit
      async updateBusinessUnit() {

        // if(this.$route.params.id == null || !this.$route.params.id) {
        //   await this.$store.dispatch("alerts/error", "error")
        //   return
        // }

        const data = {
          type: "fms_business_units",
          id: this.business_unit.id,
          business_unit_name: this.business_unit.business_unit_name,
          business_unit_remark: this.business_unit.business_unit_remark
        }

        try {
          //kirim data ke server
          await this.$store.dispatch("fms_business_unit/update", data)
          //panggil alert notifikasi sukses
          await this.$store.dispatch("alerts/success", "Business Unit data changed successfully.")
          //kembali ke list
          // await this.$router.replace({name: 'List Business Unit'});
          this.$parent.$parent.modalCloseEditFormBu();
        } catch (e) {
          //panggil notifikasi error
          await this.$store.dispatch("alerts/error", "Oops, something went wrong!")
          this.setApiValidation(e.response.data.errors)
        }

      }
    }
  };
</script>
